import { Routes } from "@angular/router";
import { authGuard } from "../auth/auth.guard";
import { AdminComponent } from "./admin/admin.component";
import { AdminDashboardComponent } from "./admin-dashboard/admin-dashboard.component";
import { SettingsComponent } from "./settings/settings.component";
import { ManageNewsComponent } from "./news/manage-news/manage-news.component";
import { NewsFormComponent } from "./news/news-form/news-form.component";
import { ManagePagesComponent } from "./pages/manage-pages/manage-pages.component";
import { PagesFormComponent } from "./pages/pages-form/pages-form.component";
import { ManageUsersComponent } from "./users/manage-users/manage-users.component";
import { UsersFormComponent } from "./users/users-form/users-form.component";
import { ManageCategoriesComponent } from "./settings/categories/manage-categories/manage-categories.component";
import { CategoriesFormComponent } from "./settings/categories/categories-form/categories-form.component";
import { ManageTagsComponent } from "./settings/tags/manage-tags/manage-tags.component";
import { TagsFormComponent } from "./settings/tags/tags-form/tags-form.component";
import { ManageTrustpilotComponent } from "./settings/trustpilot/manage-trustpilot/manage-trustpilot.component";
import { TrustpilotFormComponent } from "./settings/trustpilot/trustpilot-form/trustpilot-form.component";
import { ManageTechnologyComponent } from "./settings/technology/manage-technology/manage-technology.component";
import { TechnologyFormComponent } from "./settings/technology/technology-form/technology-form.component";
import { ManageEventsComponent } from "./events/manage-events/manage-events.component";
import { ManageCorsiComponent } from "./corsi/manage-corsi/manage-corsi.component";
import { CorsiFormComponent } from "./corsi/corsi-form/corsi-form.component";
import { ManageRequestsComponent } from "./requests/manage-requests/manage-requests.component";
import { RequestsFormComponent } from "./requests/requests-form/requests-form.component";

export const ADMIN_ROUTES: Routes = [
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [authGuard],
    children: [
      {
        path: "",
        children: [
          { path: "settings", component: SettingsComponent },

          { path: "settings/categories", component: ManageCategoriesComponent },
          {
            path: "settings/categories/edit/:id",
            component: CategoriesFormComponent,
          },
          {
            path: "settings/categories/create",
            component: CategoriesFormComponent,
          },

          { path: "settings/tags", component: ManageTagsComponent },
          { path: "settings/tags/edit/:id", component: TagsFormComponent },
          { path: "settings/tags/create", component: TagsFormComponent },

          { path: "settings/technology", component: ManageTechnologyComponent },
          {
            path: "settings/technology/edit/:id",
            component: TechnologyFormComponent,
          },
          {
            path: "settings/technology/create",
            component: TechnologyFormComponent,
          },

          { path: "news", component: ManageNewsComponent },
          { path: "news/create", component: NewsFormComponent },
          { path: "news/edit/:id", component: NewsFormComponent },

          { path: "corsi", component: ManageCorsiComponent },
          { path: "corsi/create", component: CorsiFormComponent },
          { path: "corsi/edit/:id", component: CorsiFormComponent },

          { path: "events", component: ManageEventsComponent },

          { path: "pages", component: ManagePagesComponent },
          { path: "pages/create", component: PagesFormComponent },
          { path: "pages/edit/:id", component: PagesFormComponent },

          { path: "requests", component: ManageRequestsComponent },
          { path: "requests/create", component: RequestsFormComponent },
          { path: "requests/edit/:id", component: RequestsFormComponent },

          { path: "users", component: ManageUsersComponent },
          { path: "users/create", component: UsersFormComponent },
          { path: "users/edit/:id", component: UsersFormComponent },

          { path: "", component: AdminDashboardComponent },
        ],
      },
    ],
  },
];
